











import Vue, { PropType } from "vue";
import $ from "jquery";
import "@chenfengyuan/datepicker/dist/datepicker.esm.js";
// import "@fengyuanchen/datepicker/dist/datepicker.css";

export default Vue.extend({
  props: {
    value: {},
    minDate: {
      type: Date as PropType<Date | null>
    }
  },
  mounted() {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    ($ as any).fn.datepicker.languages["ja-JP"] = {
      format: "yyyy年mm月dd日",
      days: [
        "日曜日",
        "月曜日",
        "火曜日",
        "水曜日",
        "木曜日",
        "金曜日",
        "土曜日"
      ],
      daysShort: ["日曜", "月曜", "火曜", "水曜", "木曜", "金曜", "土曜"],
      daysMin: ["日", "月", "火", "水", "木", "金", "土"],
      months: [
        "1月",
        "2月",
        "3月",
        "4月",
        "5月",
        "6月",
        "7月",
        "8月",
        "9月",
        "10月",
        "11月",
        "12月"
      ],
      monthsShort: [
        "1月",
        "2月",
        "3月",
        "4月",
        "5月",
        "6月",
        "7月",
        "8月",
        "9月",
        "10月",
        "11月",
        "12月"
      ],
      weekStart: 1,
      yearFirst: true,
      yearSuffix: "年"
    };

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const datepickerElement = $(this.$refs.datepickerElement) as any;
    datepickerElement
      .datepicker({
        language: "ja-JP",
        weekStart: 0,
        filter: (date: Date, view: string) => {
          if (view === "day" && this.minDate && date < this.minDate) {
            return false; // Disable all Sundays, but still leave months/years, whose first day is a Sunday, enabled.
          }
        }
      })
      .on("pick.datepicker", (evt: Event & { date: Date }) => {
        this.$emit("input", this.$formatter.date(evt.date));
        evt.preventDefault();
        datepickerElement.datepicker("hide");
      });
  }
});
